import Endpoint from './endpoint'
import { API_URL } from './index'

export default class CampaignCategories extends Endpoint {
  async all() {
    let url = new URL('/api/campaign_categories', API_URL)

    return this.request(url)
  }
}
